import { render, staticRenderFns } from "./ForumComment.vue?vue&type=template&id=95646376&scoped=true&"
import script from "./ForumComment.vue?vue&type=script&lang=js&"
export * from "./ForumComment.vue?vue&type=script&lang=js&"
import style0 from "./ForumComment.vue?vue&type=style&index=0&id=95646376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95646376",
  null
  
)

export default component.exports